import React from 'react';
import { BookOpenIcon, FileTextIcon } from 'lucide-react';
export function ContentSection() {
  return <section className="w-full bg-[#f5f5f5] py-8 md:py-16 px-4" data-id="element-58">
      <div className="max-w-7xl mx-auto" data-id="element-59">
        <h2 className="text-2xl md:text-5xl lg:text-6xl font-black text-gray-900 text-center mb-4 md:mb-6" data-id="element-60">
          Método Barber Pro incluye:
        </h2>
        <div className="w-20 md:w-32 h-1 bg-[#c41e3a] mx-auto mb-8 md:mb-14" data-id="element-61"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10" data-id="element-62">
          {/* Parte I */}
          <div className="bg-white rounded-lg p-6 md:p-10 shadow-lg border-4 border-gray-300 relative" data-id="element-63">
            <div className="absolute top-4 right-4 text-6xl md:text-8xl font-black text-gray-200" data-id="element-64">
              1
            </div>
            <div className="mb-5 flex justify-center relative z-10" data-id="element-65">
              <img src="https://cdn.magicpatterns.com/uploads/7KK6PQzZ9Eh7SteCr4XUUb/parte1.png" alt="Parte I - Fundamentos y Estructura Profesional" className="w-32 md:w-44 h-auto rounded-lg shadow-md" data-id="element-66" />
            </div>
            <div className="flex items-center gap-3 mb-3" data-id="element-67">
              <BookOpenIcon className="w-8 h-8 md:w-10 md:h-10 text-[#c41e3a]" aria-hidden="true" data-id="element-68" />
              <h3 className="text-xl md:text-2xl font-black text-gray-900" data-id="element-69">
                PARTE I
              </h3>
            </div>
            <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3 leading-tight" data-id="element-70">
              Fundamentos y Estructura Profesional
            </h4>
            <p className="text-gray-700 leading-relaxed text-sm md:text-base mb-4" data-id="element-71">
              Base técnica sólida, herramientas, postura y precisión desde el
              primer día.
            </p>
            {/* Badge páginas */}
            <div className="flex items-center gap-1.5 bg-[#c41e3a]/8 border border-[#c41e3a]/20 rounded-md px-3 py-1.5 w-fit" data-id="element-72">
              <FileTextIcon className="w-3.5 h-3.5 text-[#c41e3a]" aria-hidden="true" data-id="element-73" />
              <span className="text-xs font-black text-[#c41e3a] tracking-wide" data-id="element-74">
                60 páginas
              </span>
            </div>
          </div>

          {/* Parte II */}
          <div className="bg-white rounded-lg p-6 md:p-10 shadow-lg border-4 border-gray-300 relative" data-id="element-75">
            <div className="absolute top-4 right-4 text-6xl md:text-8xl font-black text-gray-200" data-id="element-76">
              2
            </div>
            <div className="mb-5 flex justify-center relative z-10" data-id="element-77">
              <img src="https://cdn.magicpatterns.com/uploads/cF1oV7reWEE8ki6yfeFVxq/parte2.png" alt="Parte II - Técnica y Aplicación Real" className="w-32 md:w-44 h-auto rounded-lg shadow-md" data-id="element-78" />
            </div>
            <div className="flex items-center gap-3 mb-3" data-id="element-79">
              <BookOpenIcon className="w-8 h-8 md:w-10 md:h-10 text-[#c41e3a]" aria-hidden="true" data-id="element-80" />
              <h3 className="text-xl md:text-2xl font-black text-gray-900" data-id="element-81">
                PARTE II
              </h3>
            </div>
            <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3 leading-tight" data-id="element-82">
              Técnica y Aplicación Real
            </h4>
            <p className="text-gray-700 leading-relaxed text-sm md:text-base mb-4" data-id="element-83">
              Fade, degradados, líneas, control y perfeccionamiento con apoyo
              visual.
            </p>
            {/* Badge páginas */}
            <div className="flex items-center gap-1.5 bg-[#c41e3a]/8 border border-[#c41e3a]/20 rounded-md px-3 py-1.5 w-fit" data-id="element-84">
              <FileTextIcon className="w-3.5 h-3.5 text-[#c41e3a]" aria-hidden="true" data-id="element-85" />
              <span className="text-xs font-black text-[#c41e3a] tracking-wide" data-id="element-86">
                60 páginas
              </span>
            </div>
          </div>

          {/* Parte III */}
          <div className="bg-white rounded-lg p-6 md:p-10 shadow-lg border-4 border-gray-300 relative" data-id="element-87">
            <div className="absolute top-4 right-4 text-6xl md:text-8xl font-black text-gray-200" data-id="element-88">
              3
            </div>
            <div className="mb-5 flex justify-center relative z-10" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/mdc15jyJnHAQyAajxhes1B/parte3.png" alt="Parte III - Negocio y Profesionalización" className="w-32 md:w-44 h-auto rounded-lg shadow-md" data-id="element-90" />
            </div>
            <div className="flex items-center gap-3 mb-3" data-id="element-91">
              <BookOpenIcon className="w-8 h-8 md:w-10 md:h-10 text-[#c41e3a]" aria-hidden="true" data-id="element-92" />
              <h3 className="text-xl md:text-2xl font-black text-gray-900" data-id="element-93">
                PARTE III
              </h3>
            </div>
            <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3 leading-tight" data-id="element-94">
              Negocio y Profesionalización
            </h4>
            <p className="text-gray-700 leading-relaxed text-sm md:text-base mb-4" data-id="element-95">
              Cómo transformar la habilidad en ingresos sostenibles. Precios,
              clientes y marca personal.
            </p>
            {/* Badge páginas */}
            <div className="flex items-center gap-1.5 bg-[#c41e3a]/8 border border-[#c41e3a]/20 rounded-md px-3 py-1.5 w-fit" data-id="element-96">
              <FileTextIcon className="w-3.5 h-3.5 text-[#c41e3a]" aria-hidden="true" data-id="element-97" />
              <span className="text-xs font-black text-[#c41e3a] tracking-wide" data-id="element-98">
                60 páginas
              </span>
            </div>
          </div>
        </div>

        {/* Resumen total */}
        <div className="mt-8 md:mt-10 flex flex-col items-center gap-3" data-id="element-99">
          <div className="flex items-center gap-2 bg-gray-900 text-white px-5 py-2.5 rounded-full" data-id="element-100">
            <FileTextIcon className="w-4 h-4 text-[#c41e3a]" aria-hidden="true" data-id="element-101" />
            <span className="text-sm md:text-base font-black tracking-wide" data-id="element-102">
              +180 páginas de formación profesional
            </span>
          </div>
          <p className="text-gray-900 text-sm md:text-base font-black text-center mt-1" data-id="element-103">
            Un sistema completo. No contenido aislado.
          </p>
          <p className="text-gray-500 text-xs md:text-sm font-semibold italic text-center" data-id="element-104">
            Todo en formato ebook profesional, pensado como manual de estudio y
            consulta permanente.
          </p>
        </div>
      </div>
    </section>;
}